import { useIntl } from 'react-intl';
import { connect } from 'react-redux';
import { v4 as uuid } from 'uuid';

import { workflowSetNotifications } from '~/actions/workflow';
import { Box } from '~/eds/src/components/Box/Box';
import { Button } from '~/eds/src/components/Button/Button';

import Section from '../Section';
import NotificationItem from './NotificationItem/NotificationItem';

function Notifications({
  notifications,
  // connected
  workflowSetNotifications,
}) {
  const intl = useIntl();

  function handleOnAddNotificationClick() {
    const newNotification = { id: uuid(), userIds: [], message: '' };
    workflowSetNotifications([...notifications, newNotification]);
  }

  function handleOnRemoveNotificationClick(notificationId) {
    const updatedNotifications = notifications.filter(
      ({ id }) => id !== notificationId,
    );
    workflowSetNotifications(updatedNotifications);
  }

  function handleOnUpdateNotification(notificationId, userIds, message) {
    const updatedNotifications = notifications.map((notification) => {
      if (notification.id !== notificationId) return notification;
      return { ...notification, userIds, message };
    });
    workflowSetNotifications(updatedNotifications);
  }

  return (
    <Section
      description={intl.formatMessage({
        id: 'Notifications.sectionDescription',
        defaultMessage:
          'Specify users who should be notified after the workflow is completed.',
        description: 'Description for notifications section',
      })}
      icon="alert"
      id="workflow--settings-notification-header"
      title={intl.formatMessage({
        id: 'Notifications.sectionTitle',
        defaultMessage: 'Notifications',
        description: 'Title for notifications section',
      })}
    >
      {notifications.map((notification) => (
        <NotificationItem
          key={notification.id}
          notification={notification}
          onRemove={() => handleOnRemoveNotificationClick(notification.id)}
          onUpdate={handleOnUpdateNotification}
        />
      ))}
      <Box>
        <Button
          text={intl.formatMessage({
            id: 'Notifications.addNotificationButton',
            defaultMessage: 'Add Notification',
            description: 'Button text for adding a notification',
          })}
          onClick={handleOnAddNotificationClick}
        />
      </Box>
    </Section>
  );
}

const mapStateToProps = ({ currentUser, workflow }) => ({
  currentUser,
  notifications: workflow.settings.notifications,
});

export default connect(mapStateToProps, { workflowSetNotifications })(
  Notifications,
);
